import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '@/context/LanguageContext';
import { seoData, getStructuredData, getHreflangLinks, DOMAIN } from '@/i18n/seoConfig';

const SEOHead = ({ page = 'home', customTitle, customDescription }) => {
  const { language } = useLanguage();
  const data = seoData[language] || seoData.es;

  const title = customTitle || data.title;
  const description = customDescription || data.description;
  const ogImage = `${DOMAIN}/og-${language}.png`;
  const canonical = `${DOMAIN}/${language}`;
  const hreflangLinks = getHreflangLinks();
  const structuredData = getStructuredData(language);

  return (
    <Helmet>
      <html lang={language} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={data.keywords} />
      <link rel="canonical" href={canonical} />

      {/* Hreflang */}
      {hreflangLinks.map((link, i) => (
        <link key={i} rel={link.rel} hrefLang={link.hrefLang} href={link.href} />
      ))}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="VendFactura" />
      <meta property="og:title" content={data.ogTitle} />
      <meta property="og:description" content={data.ogDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1536" />
      <meta property="og:image:height" content="1024" />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={data.locale} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={data.ogTitle} />
      <meta name="twitter:description" content={data.ogDescription} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured Data */}
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>

      {/* Favicon */}
      <link rel="icon" type="image/png" href="/logo.png" />
      <link rel="apple-touch-icon" href="/logo.png" />
    </Helmet>
  );
};

export default SEOHead;
